import React from "react"
import "./portfolio.css"
import ProjectImg1 from "../../assets/projects/bpgc-min.png"
import ProjectImg2 from "../../assets/projects/parikrama-min.png"
// import ProjectImg3 from "../../assets/projects/glados-min.png"
import ProjectImg4 from "../../assets/projects/tetris-min.png"
import ProjectImg5 from "../../assets/projects/random_quote_generator-min.png"
import ProjectImg6 from "../../assets/projects/compression.png"

const data = [
  // {
  //   id: 3,
  //   image: ProjectImg3,
  //   title: "Glados Chat Application",
  //   github: "https://github.com/devgoel186/GladosChat",
  //   demo: "https://glados-chat-app.netlify.app/"
  // },
  {
    id: 4,
    image: ProjectImg4,
    title: "Tetris Game Compiler",
    github: "https://github.com/devgoel186/Tetris-Compiler-CSF363",
  },
  {
    id: 1,
    image: ProjectImg1,
    title: "Aerodynamics Club Website",
    github: "https://github.com/AeroDBPGC/website",
    demo: "https://aerodbpgc.netlify.app/"
  },
  {
    id: 2,
    image: ProjectImg2,
    title: "Parikrama College Website",
    github: "https://github.com/parikrama-devs/parikrama-website",
    demo: "https://www.parikrama.edu.in/"
  },
  {
    id: 5,
    image: ProjectImg5,
    title: "Random Quote Generator",
    github: "https://github.com/devgoel186/Random-Quote-Generator",
    demo: "https://devgoel186.github.io/Random-Quote-Generator/"
  },
  {
    id: 6,
    image: ProjectImg6,
    title: "Glados Image Compressor",
    github: "https://github.com/devgoel186/Glados-Image-Compressor",
  }
]

const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {
          data.map(({id, image, title, github, demo}) => {
            return (
              <article key={id} className="portfolio__item">
                <div className="portfolio__item-image">
                  <img src={image} alt="Random" />
                </div>
                <h3>{title}</h3>
                <div className="portfolio__item-cta">
                  {github && <a href={github} className="btn" target="_blank" rel="noreferrer">Github</a>}
                  {demo && <a href={demo} className="btn btn-primary" target="_blank" rel="noreferrer">Live Demo</a>}
                </div>
              </article>
            )
          })
        }        
      </div>
    </section>
  )
}

export default Portfolio;